import { Box, Checkbox, Divider, Typography } from "@mui/material";
import React, { useState } from "react";
import { CustomButtonComponent } from "../../shared/elements/cutomBtn.component";
import { CustomInputComponent } from "../../shared/elements/customInputs.component";
import { Stack } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { useLoginHook } from "../../features/auth/hooks/auth.hook";

export const LoginForm: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const { mutate: login, isPending, error } = useLoginHook();

  const handleLogin = () => {
    login(
      { email, password },
      {
        onSuccess: (data) => {
          localStorage.setItem("accessToken", data.accessToken);
          navigate("/");
        },
      },
    );
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        overflow: "auto",
      }}
    >
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          width: "55%",
          height: "100vh",
          backgroundImage:
            "url('https://spotsxplorerapp.s3.us-east-1.amazonaws.com/images/backg-2.png')",
          backgroundSize: "cover",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src="https://spotsxplorerapp.s3.us-east-1.amazonaws.com/images/logoPng.png"
          alt="Logo"
          style={{ maxWidth: "55%" }}
        />
      </Box>

      <Box
        sx={{
          width: { xs: "100%", md: "45%" },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: { xs: "20px", sm: "32px" },
        }}
      >
        <Stack
          spacing={1}
          marginBottom={2.5}
          sx={{
            width: "100%",
            maxWidth: "320px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
            flexDirection: "row",
            fontWeight: "bold",
            fontSize: "13px",
            color: "#2d2d2d",
          }}
        >
          <Divider
            sx={{
              width: "36px",
              backgroundColor: "#A0005C",
              height: "1.5px",
              mr: { xs: "16px", sm: "60px" },
            }}
          />
          Se connecter
        </Stack>

        <Stack
          sx={{
            width: "100%",
            maxWidth: "320px",
            display: "flex",
            gap: "8px",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#2d2d2d" }}
          >
            Connectez-vous
          </Typography>

          <Typography variant="body2" sx={{ color: "#9c95957d" }}>
            Bienvenue, vous nous avez manqué !
          </Typography>
        </Stack>

        <Stack
          spacing={2}
          sx={{ width: "100%", maxWidth: "320px", marginTop: "24px" }}
        >
          <CustomInputComponent
            label="Adresse Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Entrez votre email"
            sx={{ width: "100%" }}
          />

          <CustomInputComponent
            label="Mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            placeholder="Entrez votre mot de passe"
            sx={{ width: "100%" }}
          />

          {error && (
            <Typography
              variant="body2"
              sx={{ color: "error.main", fontSize: "12px" }}
            >
              Email ou mot de passe incorrect. Veuillez réessayer.
            </Typography>
          )}

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Checkbox
                size="small"
                sx={{
                  color: "#a0005b90",
                  "&.Mui-checked": {
                    color: "#a0005b90",
                  },
                }}
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <Typography sx={{ color: "#2d2d2d", fontSize: "12px" }}>
                Me souviens
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "#a0005b90",
                fontSize: "12px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => console.log("Forgot password clicked")}
            >
              Oublie le mot de passe ?
            </Typography>
          </Box>

          <CustomButtonComponent
            label={isPending ? "Connexion..." : "Se connecter"}
            onClick={handleLogin}
            disabled={isPending || !email || !password}
            variant="contained"
            sx={{ width: "100%" }}
          />
        </Stack>
      </Box>
    </Box>
  );
};
